import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import './BatchesSelector.scss';

let searchInputIdCounter = 0;

export const BatchesSelector = (props) => {
  const { batches, getSelectedBatches, title, selectBatches, sendBoth, isStudentFee, removeAll } =
    props;
  // const [selectedBatches, setSelectedBatches] = useState([...selectBatches]);
  const [selectedBatches, setSelectedBatches] = useState(
    Array.isArray(selectBatches) ? [...selectBatches] : [],
  );
  const [selectedBatchesId, setSelectedBatchesId] = useState(
    selectedBatches.map((ele) => ele.client_batch_id),
  );
  const [selectAllStudents, setSelectAllStudents] = useState(false);
  const [allBatches, setAllBatches] = useState([]);
  const [removedBatches, setRemovedBatches] = useState([]);
  const [searchString, setSearchString] = useState('');

  const batchesLength = useRef(0);
  const searchInputRef = useRef(null);
  const searchInputId = useRef(`batches-search-${(searchInputIdCounter += 1)}`).current;

  useEffect(() => {
    const allUniqueBatches = batches.filter((unique) => {
      const uniqueBatch = selectedBatches.find(
        (common) => common.client_batch_id === unique.client_batch_id,
      );
      return !uniqueBatch;
    });

    setAllBatches(allUniqueBatches);
  }, []);

  useEffect(() => {
    if (isStudentFee) {
      setAllBatches(batches?.filter((batch) => !selectedBatches.includes(batch)));
    }
  }, [isStudentFee, batches]);

  useEffect(() => {
    
    if (sendBoth) getSelectedBatches(allBatches, selectedBatches, removedBatches);
    else getSelectedBatches(selectedBatches);
  }, [selectedBatches, getSelectedBatches, allBatches, sendBoth]);

  const selectBatch = (elem) => {
    // const batchess = allBatches.filter((e) => e.client_batch_id !== elem.client_batch_id);
    const batchess = [...allBatches];
    const newRemoved = removedBatches.filter(
      (batch) => batch.client_batch_id !== elem.client_batch_id,
    );
    const index = batchess.findIndex((e) => e.client_batch_id === elem.client_batch_id);
    batchess.splice(index, 1);
    setAllBatches(batchess);
    setRemovedBatches(newRemoved);
    setSelectedBatches((prevstate) => [...prevstate, elem]);
  };
  const removeBatch = (elem) => {
    const newRemoved = [...removedBatches];
    newRemoved.push(elem);
    setRemovedBatches(newRemoved);
    const batchess = [...allBatches];
    const index = selectedBatches.findIndex((e) => e.client_batch_id === elem.client_batch_id);
    batchess.unshift(elem); // Changed from push(elem) to unshift(elem)
    setAllBatches(batchess);
    setSelectedBatches((prevstate) => [
      ...prevstate.slice(0, index),
      ...prevstate.slice(index + 1),
    ]);
  };

  const selectAll = (val) => {
    console.log(val);
    if (val) {
      setSelectedBatches(() => [...batches]);
      setAllBatches([]);
    } else {
      setAllBatches(() => [...selectedBatches]);
      setSelectedBatches([]);
    }
    setSelectAllStudents(val);
  };

  return (
    <>
      <div className='d-flex my-2 justify-content-center align-items-center'>
        <Form.Check
          type='checkbox'
          checked={selectAllStudents}
          onChange={(e) => selectAll(!selectAllStudents)}
          className=' d-flex align-items-center m-2 mb-1 font-bold'
          label=''
          name='selectAll'
        />
        <span className='font-bold mt-1'>Select All</span>
      </div>
      <Row className='Batches py-3'>
        <Col
          style={{ borderRight: '0.5px solid lightgray' }}
          xs={6}
          className='BatchesCol pr-0 text-center'
        >
          <h6 className='mb-4 font'>{title}</h6>
          <div className='Batches__totalBatches'>
            <label
              style={{ width: '90%' }}
              htmlFor={searchInputId}
              onClick={() => searchInputRef.current.focus()}
              className='d-flex has-float-label my-2 mx-2'
            >
              <input
                ref={searchInputRef}
                className='form-control'
                id={searchInputId}
                name='Batches'
                type='text'
                placeholder={`Search ${title}`}
                onChange={(e) => setSearchString(e.target.value)}
                value={searchString}
              />
              <span
                style={{ pointerEvents: 'auto', cursor: 'text' }}
                onClick={() => searchInputRef.current?.focus()}
              >
                Search {title}
              </span>
            </label>
            {allBatches.length <= 0 && (
              <p className='text-center font' style={{ marginTop: '50px' }}>
                Nothing left in this side.
              </p>
            )}
            {allBatches?.length > 0 &&
              allBatches
                .filter((ele) => {
                  if (title === 'Courses') {
                    return ele.course_title.includes(searchString?.toLowerCase());
                  }
                  return ele?.batch_name?.toLowerCase()?.includes(searchString?.toLowerCase());
                })
                .map((elem) => {
                  return (
                    <Row
                      className=' justify-content-center mb-1 mx-0'
                      key={`elem${elem.client_batch_id}${elem.batch_name}`}
                      style={
                        Object.prototype.hasOwnProperty.call(elem, 'dontShow') && elem.dontShow
                          ? { display: 'none' }
                          : {}
                      }
                    >
                      <Button
                        className='btn_main'
                        variant='batchCustomNotSelected'
                        onClick={() => selectBatch(elem)}
                      >
                        {elem.batch_name}
                      </Button>
                    </Row>
                  );
                })}
          </div>
        </Col>

        <Col
          style={{ borderLeft: '0.5px solid lightgray' }}
          xs={6}
          className='BatchesCol pl-0 text-center'
        >
          <h6 className='mb-4 font'>{selectedBatches.length} Selected</h6>
          {selectedBatches.map((elem) => {
            if(!elem.batch_name) return null;
            return (
              <Row
                className='justify-content-center  mb-1 mx-0'
                key={`e123${elem.client_batch_id}${elem.count}`}
              >
                <Button
                  className='btn_main'
                  variant='customLightBlue'
                  onClick={() => removeBatch(elem)}
                  style={isStudentFee && elem.is_fee === 'true' ? { opacity: '0.6' } : {}}
                >
                  {elem.batch_name}
                </Button>
              </Row>
            );
          })}
        </Col>
      </Row>
    </>
  );
};

BatchesSelector.propTypes = {
  getSelectedBatches: PropTypes.func.isRequired,
  selectBatches: PropTypes.instanceOf(Array).isRequired,
  batches: PropTypes.instanceOf(Array).isRequired,
  title: PropTypes.string.isRequired,
  sendBoth: PropTypes.bool,
  isStudentFee: PropTypes.bool,
  removeAll: PropTypes.func,
};

BatchesSelector.defaultProps = {
  sendBoth: false,
  isStudentFee: false,
  removeAll: () => {},
};
